module.exports = __webpack_public_path__ + "c8974e78a8b83efc8bd37b20d3b6b1d1.png";